module.exports = __webpack_public_path__ + "img/error_403.e7927eaf.svg";